document.addEventListener("DOMContentLoaded", function () {
  const stickyCart = document.querySelector(".sticky-cart");

  // スクロール位置を監視してsticky-cartの表示/非表示を制御
  function handleScroll() {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    
    // 画面の最下部に到達したかどうかを判定（少し余裕を持たせて100px手前で判定）
    const isAtBottom = scrollY + windowHeight >= documentHeight - 100;
    
    if (scrollY > 400 && !isAtBottom) {
      // 400px過ぎていて、かつ最下部でない場合に表示
      stickyCart.classList.add("show");
    } else {
      // 400px以下、または最下部の場合は非表示
      stickyCart.classList.remove("show");
    }
  }

  // スクロールイベントを追加
  window.addEventListener("scroll", handleScroll);
});